var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLookingToFormalize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF2FA;}\n\t.st1{fill:none;stroke:#1930AB;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.4,41.3c0,0,202.7,139.8,169.6,302.9c0,0-34.4,170.3-313.4,137.5c-52.2-6.1-100.1-30.9-131.4-70.3 C27.9,392,16.4,369.9,9.5,346.2C-4,301.4,2,253.2,24.7,211.5C74.3,120.4,190.5-52.7,318.4,41.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.2,244.5C186,234.1,181,221,181,206.8c0-33.6,27.2-60.8,60.8-60.8s60.8,27.2,60.8,60.8 c0,13-4.1,25-11,34.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231,184.5c5.4-9.4,18.1-9.4,23.5,0l56.2,98l54.8,95.5c5.7,10-0.9,22.9-11.7,22.9h-111h-111 c-10.9,0-17.5-12.9-11.7-22.9l54.8-95.5L231,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.9,271.6l-2.2-3.2c-1.8-2.5-4.9-3.7-7.9-2.8l-13.8,4c-3,0.9-6.2-0.3-7.9-2.9l-2.4-3.6 c-1.8-2.7-1.6-6.3,0.6-8.8l10.8-12.1c1.6-1.8,2.2-4.3,1.6-6.6l-2.6-10c-0.6-2.3-2.3-4.1-4.5-4.9l-15-5.3c-2.7-1-4.6-3.4-4.7-6.3 l-0.3-5.1c-0.2-3.3,1.8-6.3,4.9-7.3l16-5.3c2.6-0.9,4.5-3.2,4.9-5.9l1.3-10c0.3-2.1-0.4-4.3-1.9-5.9l-12.2-12.7 c-2-2.1-2.6-5.2-1.4-7.8l1.4-3.3c1.4-3.3,5.1-5,8.5-4l16.7,4.7c2.4,0.7,5,0.1,6.8-1.6l8-7.4c2.1-1.9,2.8-4.8,1.9-7.5L178,114 c-1-3.1,0.2-6.6,3-8.3l5.1-3.2c2.8-1.8,6.4-1.4,8.8,0.9l13.2,12.7c1.6,1.5,3.8,2.2,6,1.9l8.9-1.3c2.8-0.4,5.1-2.4,5.9-5.1 l3.9-13.9c0.9-3.3,4.1-5.5,7.6-5.2l6.4,0.6c2.8,0.3,5.2,2.2,6.1,4.9l5.3,16.2c0.7,2.2,2.4,3.9,4.6,4.6l8.8,2.9 c2.7,0.9,5.7,0.1,7.6-2l10-11.2c2.6-2.9,6.9-3.2,9.9-0.8l4.4,3.6c2.2,1.8,3.1,4.6,2.4,7.3l-3.3,12.8c-0.6,2.4,0.1,5,1.8,6.8l6.8,7 c1.8,1.9,4.5,2.6,7,1.9l14.5-4c3.4-0.9,7,0.7,8.4,3.9l2.8,6.1c1.3,2.8,0.6,6.2-1.7,8.3l-10,9.2c-2,1.8-2.8,4.6-2.1,7.2l2.9,10.6 c0.7,2.4,2.5,4.3,4.9,5l13.4,3.9c3.1,0.9,5.2,3.7,5.2,6.9v8.5c0,3.5-2.6,6.6-6.1,7.1l-13,2c-3.4,0.5-5.9,3.3-6.1,6.7l-0.5,9.8 c-0.1,2,0.6,4,2,5.4l7.9,8.1c2.1,2.2,2.6,5.4,1.3,8.1l-2.9,6c-1.7,3.5-5.8,5-9.3,3.4l-10.5-4.7c-2.8-1.2-6-0.6-8.1,1.6l-1.6,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241,324.6L241,324.6c-7.6,0-13.8-6.2-13.8-13.8v-63.5c0-7.6,6.2-13.8,13.8-13.8h0c7.6,0,13.8,6.2,13.8,13.8 v63.5C254.8,318.4,248.7,324.6,241,324.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 242,
    cy: 357.5,
    r: 14.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookingToFormalize);
export default __webpack_public_path__ + "static/media/looking_to_formalize.38fa5a1bc20c024e26d6b8f69197b612.svg";
export { ForwardRef as ReactComponent };